<template>
  <div class="ts-space-y-3">
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-text-xs">
          {{
          $t('dealerUser.password')
          }}
        </label>
        <input
          v-model="model.password"
          type="password"
          class="form-control"
          :class="{ 'is-invalid': errors.has('password') }"
        />
        <div
          class="invalid-feedback"
          v-if="errors.has('password')"
        >{{ errors.first('password') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-text-xs">
          {{
          $t('dealerUser.confirm')
          }}
        </label>
        <input
          v-model="model.password_confirmation"
          type="password"
          class="form-control"
          :class="{ 'is-invalid': errors.has('password_confirmation') }"
        />
        <div
          class="invalid-feedback"
          v-if="errors.has('password_confirmation')"
        >{{ errors.first('password_confirmation') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 ts-space-x-3 ts-text-right ts-mt-3">
        <ts-button @click.prevent="$emit('close')">{{ $t('cancel') }}</ts-button>
        <ts-button color="primary" @click.prevent="onSave" :waiting="waiting">{{ $t('update') }}</ts-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'frmUpdateUser',
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      model: {
        user_id: 0,
        password: null,
        password_confirmation: null
      }
    }
  },
  computed: {
    ...mapState('administrator/dealerUser', ['edit_data'])
  },
  created() {
    this.model.user_id = this.edit_data.user_id
  },
  methods: {
    ...mapActions('administrator/dealerUser', ['resetpwd']),
    onSave() {
			this.waiting = true
			this.errors = new Errors()
			this.resetpwd(this.model)
				.then(response => {
					this.$toasted.success(response.message)
          this.$emit('close')
				})
				.catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
		}
  }
}
</script>